export default function BrowserTopMobile() {
  return (
    <svg
      width="100%"
      viewBox="0 0 360 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_395_63806)">
        <path
          d="M0 10C0 4.47715 4.47715 0 10 0H350C355.523 0 360 4.47715 360 10V62H0V10Z"
          fill="white"
        />
        <rect width="360" height="62" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.7115 29.5239L22.5366 22L14.2885 29.484C13.9207 29.815 13.9021 30.3695 14.2469 30.7225C14.5918 31.0756 15.1695 31.0935 15.5373 30.7625L16.044 30.3021V36.1502C16.044 37.1719 16.9069 38.0001 17.9713 38.0001H27.1008C28.1652 38.0001 29.0281 37.1719 29.0281 36.1502V30.4008L29.4627 30.8025C29.8305 31.1334 30.4083 31.1156 30.7531 30.7625C31.098 30.4095 31.0793 29.8549 30.7115 29.5239ZM27.2022 28.7136L22.5366 24.4022L17.8699 28.6429V36.1502C17.8699 36.204 17.9153 36.2476 17.9713 36.2476H27.1008C27.1568 36.2476 27.2022 36.204 27.2022 36.1502V28.7136Z"
          fill="#3D4043"
        />
        <rect x="45" y="12" width="228" height="36" rx="18" fill="#F1F3F4" />
        <g clip-path="url(#clip1_395_63806)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M294.047 21.75C291.674 21.75 289.75 23.6738 289.75 26.0469V33.9531C289.75 36.3262 291.674 38.25 294.047 38.25H301.953C304.326 38.25 306.25 36.3262 306.25 33.9531V26.0469C306.25 23.6738 304.326 21.75 301.953 21.75H294.047ZM291.469 26.0469C291.469 24.623 292.623 23.4688 294.047 23.4688H301.953C303.377 23.4688 304.531 24.623 304.531 26.0469V33.9531C304.531 35.377 303.377 36.5312 301.953 36.5312H294.047C292.623 36.5312 291.469 35.377 291.469 33.9531V26.0469ZM297.667 34H298.967V26.1528H298.801L295.75 27.2754V28.3765L297.667 27.7212V34Z"
            fill="#3D4043"
          />
        </g>
        <g clip-path="url(#clip2_395_63806)">
          <path
            d="M335 26C336.1 26 337 25.1 337 24C337 22.9 336.1 22 335 22C333.9 22 333 22.9 333 24C333 25.1 333.9 26 335 26ZM335 28C333.9 28 333 28.9 333 30C333 31.1 333.9 32 335 32C336.1 32 337 31.1 337 30C337 28.9 336.1 28 335 28ZM335 34C333.9 34 333 34.9 333 36C333 37.1 333.9 38 335 38C336.1 38 337 37.1 337 36C337 34.9 336.1 34 335 34Z"
            fill="#3D4043"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_395_63806">
          <path
            d="M0 10C0 4.47715 4.47715 0 10 0H350C355.523 0 360 4.47715 360 10V62H0V10Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_395_63806">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(287 19)"
          />
        </clipPath>
        <clipPath id="clip2_395_63806">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(323 18)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
